import React from 'react'

import { Text, useToast } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

import {
  loadCaseworkInstance,
  updateCaseworkInstance,
} from '../../../../redux/features/caseworkSlice'
import { calculateMS } from '../../../../utils'
import { ConfirmActionDialog } from '../../../ui'

const ArchiveDialog = ({ case_num, ...props }) => {
  const dispatch = useDispatch()
  const toast = useToast()

  const handleConfirm = () => {
    dispatch(
      updateCaseworkInstance({
        values: {
          case_num,
          status: 'Archived',
        },
        callbackSuccess: () => {
          dispatch(loadCaseworkInstance({ case_num }))
          toast({
            title: 'Successfully archived casework',
            status: 'info',
            duration: calculateMS(3),
          })
        },
        callbackFailure: () => {
          toast({
            title: 'Something went wrong trying to archive this casework.',
            status: 'error',
            duration: calculateMS(3),
          })
        },
      })
    )
    props.onClose()
  }

  return (
    <ConfirmActionDialog onConfirm={handleConfirm} {...props}>
      <Text as='b'> This casework will be archived. </Text>
      <Text>
        Only Council Connect administrators will be able to unarchive this
        casework.
      </Text>
    </ConfirmActionDialog>
  )
}

export default ArchiveDialog
